import React, { useState } from 'react'
import { useEffect } from 'react';
import { getDefaultName } from '../utils';
import { loadCountry } from '../utils/Network';

export default function CountryName({ id}) {

    const [country, setCountry] = useState(null);

    
    useEffect(() => {
        if (id)
            loadCountry(id).then(talent=>{
                setCountry(talent)
            })
        
    }, [])

    
    
    return (
        <>
            {country && getDefaultName(country.names)}
        </>
    )
}
